import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgSocialInstagram = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M12.006 6.864a5.14 5.14 0 0 1 5.14 5.138 5.14 5.14 0 0 1-10.28 0 5.14 5.14 0 0 1 5.14-5.138Zm0 1.806a3.333 3.333 0 1 0-.001 6.666 3.333 3.333 0 0 0 0-6.666Z"
      clipRule="evenodd"
    />
    <path
      fill="#88827E"
      d="M17.349 5.462a1.2 1.2 0 1 1-.001 2.397 1.2 1.2 0 0 1 0-2.397Z"
    />
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M12.006 2c2.716 0 3.056.012 4.127.063 1.063.047 1.79.218 2.428.464a4.892 4.892 0 0 1 1.77 1.153 4.685 4.685 0 0 1 1.145 1.778c.246.633.419 1.363.465 2.426.047 1.067.059 1.407.059 4.122s-.012 3.055-.059 4.122c-.046 1.063-.22 1.79-.465 2.427a4.888 4.888 0 0 1-1.153 1.769 4.89 4.89 0 0 1-1.77 1.153c-.634.246-1.365.418-2.428.464-1.067.047-1.407.059-4.123.059-2.717 0-3.057-.012-4.124-.059-1.063-.046-1.79-.218-2.427-.464a4.89 4.89 0 0 1-1.77-1.153 4.88 4.88 0 0 1-1.157-1.774c-.247-.633-.418-1.363-.465-2.426C2.012 15.057 2 14.717 2 12.002s.012-3.055.059-4.126c.047-1.063.218-1.79.465-2.426A4.901 4.901 0 0 1 3.68 3.68a4.884 4.884 0 0 1 1.774-1.157c.633-.246 1.364-.418 2.427-.464C8.95 2.012 9.29 2 12.006 2Zm0 1.801c-2.674 0-2.99.012-4.042.059-.973.043-1.504.207-1.856.343-.465.18-.797.395-1.149.747a3.094 3.094 0 0 0-.747 1.148c-.136.352-.301.88-.344 1.856-.047 1.051-.059 1.368-.059 4.04 0 2.668.012 2.986.059 4.04.043.973.208 1.505.344 1.856.18.465.395.797.747 1.149.348.347.684.566 1.149.746.352.137.88.3 1.857.344 1.05.047 1.367.058 4.04.058 2.67 0 2.987-.011 4.042-.058.973-.043 1.505-.207 1.856-.344a3.08 3.08 0 0 0 1.15-.746c.347-.348.566-.684.746-1.149.137-.351.302-.879.345-1.856.046-1.05.058-1.368.058-4.04 0-2.668-.012-2.985-.059-4.04-.043-.973-.207-1.504-.344-1.856a3.076 3.076 0 0 0-.747-1.148 3.095 3.095 0 0 0-1.149-.747c-.351-.136-.88-.3-1.856-.343-1.051-.047-1.368-.059-4.041-.059Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialInstagram;
